import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import styled from 'styled-components';

const StyledProductsSelected = styled.div`
  > div {
    position: absolute;
    width: 100%;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    > div {
      &:first-child {
        border: 1px solid #65AC1E;
        width: 60px;
        height: 60px;
        margin: 0 auto;
        color: #65AC1E;
        font-size: 2em;
        text-align: center;
        border-radius: 30px;
        line-height: 56px;
      }
    }
    span {
      font-size: 0.625em;
      color: #fff;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-top: 16px;
      display: inline-block;
    }
    button {
      margin: 20px auto 0;
    }
  }
`;

export default function ProductsSelected (props) {

  const {cnt, apply} = props;

  return (
    <StyledProductsSelected props={props}>
      <div>
        <div>{cnt}</div>
        <span>Products selected</span>
        {!!apply &&
        <Button rounded medium greenBright onClick={apply} label="Apply"/>
        }
      </div>
    </StyledProductsSelected>)
}

ProductsSelected.propTypes = {
  apply: PropTypes.func,
  data: PropTypes.object
};
